import React, { useMemo } from 'react';
import FilterDropdown, {
  DARK_THEME,
  FilterDropdownTheme,
} from 'components/search-bar/advanced-search/filter-dropdown';
import ButtonGroup from 'components/control/button-group';
import { getListingStatusLabel } from 'utils/listing-query-helper';
import { searchFilterIds } from 'constants/test-constants';
import { StatusOptions } from 'utils/select-options';
import { getLocalizedStatusOptions } from 'utils/localized-select-options';
import { useTranslation } from 'next-i18next';
import { Namespaces } from 'types/locales';
import {
  AVAILABLE_STATUS,
  NOT_AVAILABLE_OTHER_STATUS,
  NOT_AVAILABLE_SOLD_STATUS,
  PENDING_STATUS,
  type Status,
} from 'contexts/preferences/listing-params/types';

//#region Types
export type ListingStatusFilterDropdownProps = {
  rental: boolean;
  status: Status;
  theme?: FilterDropdownTheme;
  statuses?: readonly StatusOptions[];
  onValueChange(value: Status): void;
};
//#endregion


export const ALL_STATUS_OPTIONS: readonly StatusOptions[] = [AVAILABLE_STATUS, NOT_AVAILABLE_SOLD_STATUS, NOT_AVAILABLE_OTHER_STATUS, PENDING_STATUS] as const;
export const AVAILABLE_AND_NOT_AVAILABLE_SOLD_STATUS_OPTIONS: readonly StatusOptions[] = [AVAILABLE_STATUS, NOT_AVAILABLE_SOLD_STATUS] as const;

//#endregion

//#region Component
const ListingStatusFilterDropdown = ({ rental, status, onValueChange, theme = DARK_THEME, statuses = ALL_STATUS_OPTIONS }: ListingStatusFilterDropdownProps) => {
  const { t } = useTranslation(Namespaces.SEARCH);
  const searchStatusOptions = getLocalizedStatusOptions(t, rental, true, statuses);

  const listingStatusFilterLabel = useMemo(() => {
    return `${getListingStatusLabel(status, rental)} Listings`;
  }, [rental, status]);

  return (
    <FilterDropdown
      theme={theme}
      label={listingStatusFilterLabel}
      testId={searchFilterIds.listingStatusDropdownMap}
    >
      <ButtonGroup
        value={status}
        onValueChange={onValueChange}
        options={searchStatusOptions}
        size={'large'}
      />
    </FilterDropdown>
  );
};
//#endregion

export default ListingStatusFilterDropdown;